import { combineReducers }  from 'redux';
import { routerReducer }    from 'react-router-redux';
import AXGSchema from './axg-schema'
import AXGView from './axg-view'
import AXGState from './axg-state'
import AXGData from './axg-data'
import AXGAccount from './axg-account'

// export default combineReducers({
//   routing: routerReducer,
//   AXGSchema : AXGSchema,
//   AXGView : AXGView,
//   AXGState : AXGState,
//   AXGAccount: AXGAccount,
// })

module.exports = {
  combinedReducers: combineReducers({
    routing: routerReducer,
    AXGSchema : AXGSchema,
    AXGView : AXGView,
    AXGState : AXGState,
    AXGAccount: AXGAccount,
    AXGData: AXGData,
  }),
  AXGSchema,
  AXGView,
  AXGState,
  AXGData,
  AXGAccount,
}



// WEBPACK FOOTER //
// ./redux/reducers/index.js